import { LocaleSpecificGroup } from 'utils/override';

export const baseTranslations = {
  login: {
    _: 'Log in',
    zh: '登入',
  },
  logout: {
    _: 'Logout',
    zh: '登出',
  },
  defaultGiftAmountLabel: {
    _: '',
    zh: '貸款額',
  },
  defaultGiftAmountSuffix: {
    _: 'and above',
    zh: '或以上',
  },
  reward_modal_loan_amount_with_end: {
    _: ':start - :end',
    zh: ':label :start - :end',
  },
  reward_modal_loan_amount_without_end: {
    _: ':start',
    zh: ':label :start',
  },
  personal_loan_amount: {
    _: 'Loan Amount (:currency)',
    zh: '貸款額 (:currency)',
  },
  defaultGiftTenureLabel: {
    _: '',
    zh: '還款期',
  },
  defaultGiftTenureWithOutEndSuffix: {
    _: '',
    zh: '個月或以上',
  },
  defaultGiftTenureWithEndSuffix: {
    _: '',
    zh: '個月',
  },
  reward_modal_tenure_with_end: {
    _: ':start - :end month tenure',
    zh: ':label :prefix:start :suffix - :prefix:end :suffix',
  },
  reward_modal_tenure_without_end: {
    _: ':start month tenure :suffix',
    zh: ':label :start :suffix',
  },
  amount: {
    _: 'amount',
    zh: '金额',
  },
  loan_tenure: {
    _: 'Loan tenure',
    zh: '貸款期限',
  },
  tenure: {
    _: 'Tenure',
    zh: '貸款期限',
  },
  tenure_maximum_value: {
    _: 'max. 7 years',
    zh: '最多 7 年',
  },
  max: {
    _: 'max.',
    zh: '最大值',
  },
  year_short: {
    _: 'yr|yrs',
    zh: '年|年',
  },
  year_long: {
    _: 'year|years',
    zh: '年|年',
  },
  month_short: {
    _: 'mo|mos',
    zh: '月|月',
  },
  month_long: {
    _: 'month|months',
    zh: '月|月',
  },
  on_app: {
    _: 'on :app',
    zh: '在 :app 上',
  },
  on_provider_website: {
    _: "on :provider's website",
    zh: '在 :provider 的網站',
  },
  pros_cons: {
    _: 'Pros & Cons',
    zh: '優點與缺點',
  },
  offers_rewards: {
    _: 'Offers & Rewards',
    zh: '優惠與回贈',
  },
  loan_details: {
    _: 'Loan details',
    zh: '產品資訊',
  },
  eligible_rewards: {
    _: 'Eligible rewards',
    zh: '可獲得的優惠',
  },
  card_details: {
    _: 'Card Details',
    zh: '信用卡詳情',
  },
  card_details_ti_ci: {
    _: 'Card Details',
    zh: '產品詳情',
  },
  stk_bka_product_details: {
    _: 'Product Details',
    zh: '產品資訊',
  },
  updated: {
    _: 'Updated',
    zh: '更新日期',
  },
  promo_code: {
    _: 'Promo Code',
    zh: '優惠碼',
  },
  approval_odds_last_updated: {
    _: 'Approval odds last updated :date',
    zh: '批核機會最後更新於 :date',
  },
  approval_odds_refresh: {
    _: 'Refresh',
    zh: '更新',
  },
  approval_odds_date_format: {
    _: 'dd MMM yyyy',
    zh: 'yyyy年M月d日',
  },
  written_by: {
    _: 'Written by',
    zh: '作者',
  },
  read_more: {
    _: 'Read More',
    zh: '閱讀更多',
  },
  read_less: {
    _: 'Read Less',
    zh: '收起',
  },
  frequently_asked_questions: {
    _: 'Frequently Asked Questions',
    zh: '常見問題',
  },
  about_the_author: {
    _: 'About the author',
    zh: '關於作者',
  },
  tags: {
    _: 'Tags',
    zh: '標籤',
  },
  related_articles: {
    _: 'Related articles',
    zh: '相關文章',
  },
  n_a: {
    _: 'N/A',
    zh: '不適用',
  },
  express_buy: {
    _: 'Express Buy',
    zh: '立即投保',
  },
  buy: {
    _: 'Buy',
    zh: '投保',
  },
  learn_more: {
    _: 'Learn More',
    zh: '了解更多',
  },
  more_like_this: {
    _: 'More like this',
    zh: '類似產品',
  },
  see_less: {
    _: 'See less',
    zh: '顯示更少',
  },
  see_more: {
    _: 'See more',
    zh: '顯示更多',
  },
  show_less: {
    _: 'Show less',
    zh: '顯示更少',
  },
  show_more: {
    _: 'Show more',
    zh: '顯示更多',
  },
  compare_provider_plans: {
    _: 'Compare :provider Plans',
    zh: '比較 :provider 計劃',
  },
  compare_now: {
    _: 'Compare now',
    zh: '立即比較',
  },
  indicative_cost: {
    _: 'Indicative cost',
    zh: '參考費用',
  },
  enter_discount_code: {
    _: 'Enter discount code',
    zh: '輸入折扣碼',
  },
  expert_say: {
    _: 'Expert say',
    zh: '專家意見',
  },
  compare_all_plans: {
    _: 'Compare All Plans',
    zh: '比較所有計劃',
  },
  link_copied_to_clipboard: {
    _: 'Link copied to clipboard!',
    zh: '連結已複製到剪貼板！',
  },
  failed_to_copy: {
    _: 'Failed to copy',
    zh: '複製失敗',
  },
  failed_to_send_feedback: {
    _: 'Failed to send feedback',
    zh: '回饋發送失敗',
  },
  thank_you_for_the_feedback: {
    _: 'Thank you for the feedback',
    zh: '感謝您的回饋',
  },
  submitting: {
    _: 'Submitting',
    zh: '提交中',
  },
  subscribe: {
    _: 'Subscribe',
    zh: '訂閱',
  },
  enter_your_email: {
    _: 'Enter your email',
    zh: '輸入您的電子郵件',
  },
  subscription_successful: {
    _: 'Subscription successful',
    zh: '訂閱成功',
  },
  error_form: {
    _: 'There was an error submitting the form',
    zh: '提交表單時發生錯誤',
  },
  apply_now: {
    _: 'Apply Now',
    zh: '立即申請',
  },
  apply: {
    _: 'Apply',
    zh: '立即申請',
  },
  personalized_loan_text: {
    _: 'Find your personalized loan options in minutes, for Free!',
    zh: '只需幾分鐘，就可以免費揾出最適合的私人貸款！',
  },
  personalized_loan_q1: {
    _: '1. How much do you want to borrow?',
    zh: '1. 你想申請的貸款額是多少?',
  },
  personalized_loan_q1_a1: {
    _: 'Below HK$100,000',
    zh: '少於HK$100,000',
  },
  personalized_loan_q1_a2: {
    _: 'HK$100,000 - HK$299,999',
    zh: 'HK$100,000 - HK$299,999',
  },
  personalized_loan_q1_a3: {
    _: 'HK$300,000 - HK$499,999',
    zh: 'HK$300,000 - HK$499,999',
  },
  personalized_loan_q1_a4: {
    _: 'HK$500,000 - HK$699,999',
    zh: 'HK$500,000 - HK$699,999',
  },
  personalized_loan_q1_a5: {
    _: 'HK$700,000 - HK$999,999',
    zh: 'HK$700,000 - HK$999,999',
  },
  personalized_loan_q1_a6: {
    _: 'HK$1,000,000 or above',
    zh: 'HK$1,000,000 或以上',
  },
  personalized_loan_q2: {
    _: '2. How are you going to use the money?',
    zh: '2. 你的貸款用途是甚麼?',
  },
  personalized_loan_q2_a1: {
    _: 'Debt clearance',
    zh: '清卡數/債務',
  },
  personalized_loan_q2_a2: {
    _: 'Home improvement',
    zh: '家居裝修',
  },
  personalized_loan_q2_a3: {
    _: 'Medical emergency',
    zh: '緊急醫療開支',
  },
  personalized_loan_q2_a4: {
    _: 'Major purchase',
    zh: '大額消費',
  },
  personalized_loan_q2_a5: {
    _: 'Tax Loan',
    zh: '稅務貸款',
  },
  personalized_loan_q2_a6: {
    _: 'Business usage',
    zh: '商業用途',
  },
  personalized_loan_q2_a7: {
    _: 'Education',
    zh: '教育/進修',
  },
  personalized_loan_q2_a8: {
    _: 'Investment',
    zh: '投資',
  },
  personalized_loan_q2_a9: {
    _: 'Car purchase',
    zh: '買車',
  },
  personalized_loan_q2_a10: {
    _: 'Other',
    zh: '其他',
  },
  personalized_loan_q3: {
    _: "3. What's your employment status?",
    zh: '3. 以下那一個是你的就業現況?',
  },
  personalized_loan_q3_a1: {
    _: 'Full-time',
    zh: '全職工作',
  },
  personalized_loan_q3_a2: {
    _: 'Part-time',
    zh: '兼職工作',
  },
  personalized_loan_q3_a3: {
    _: 'Self-employed',
    zh: '自傭人士',
  },
  personalized_loan_q3_a4: {
    _: 'Student',
    zh: '學生',
  },
  personalized_loan_q3_a5: {
    _: 'Unemployed',
    zh: '無業',
  },
  personalized_loan_q3_a6: {
    _: 'Retired',
    zh: '退休',
  },
  personalized_loan_q3_a7: {
    _: 'Domestic helper',
    zh: '家庭傭工',
  },
  personalized_loan_q3_a8: {
    _: 'Other',
    zh: '其他',
  },
  personalized_loan_q4: {
    _: "4. What's your annual income?",
    zh: '4. 你的年收入約為多少?',
  },
  personalized_loan_q4_a1: {
    _: 'Less than HK$180,000',
    zh: '少於HK$180,000',
  },
  personalized_loan_q4_a2: {
    _: 'HK$180,000 - HK$359,999',
    zh: 'HK$180,000 - HK$359,999',
  },
  personalized_loan_q4_a3: {
    _: 'HK$360,000 - HK$719,999',
    zh: 'HK$360,000 - HK$719,999',
  },
  personalized_loan_q4_a4: {
    _: 'HK$720,000 - HK$1,199,999',
    zh: 'HK$720,000 - HK$1,199,999',
  },
  personalized_loan_q4_a5: {
    _: 'HK$1,200,000 or above',
    zh: 'HK$1,200,000或以上',
  },
  personalized_loan_q5: {
    _: '5. How old are you?',
    zh: '5. 你屬於那一個年齡組別?',
  },
  personalized_loan_q5_a1: {
    _: 'Less than 21',
    zh: '少於21歲',
  },
  personalized_loan_q5_a2: {
    _: '21-30',
    zh: '21歲 - 30歲',
  },
  personalized_loan_q5_a3: {
    _: '31-40',
    zh: '31歲- 40歲',
  },
  personalized_loan_q5_a4: {
    _: '41-50',
    zh: '41歲 - 50歲',
  },
  personalized_loan_q5_a5: {
    _: '51-60',
    zh: '51歲 - 60歲',
  },
  personalized_loan_q5_a6: {
    _: '61 or above',
    zh: '60歲或以上',
  },
  personalized_loan_q6: {
    _: '6. What’s your estimated credit score?',
    zh: '6. 你估計你的信貸評級是甚麼?',
  },
  personalized_loan_q6_a1: {
    _: 'Excellent : 3526 - 4000',
    zh: '優良 : 3526 - 4000',
  },
  personalized_loan_q6_a2: {
    _: 'Very good : 3240 - 3525',
    zh: '良好 : 3240 - 3525',
  },
  personalized_loan_q6_a3: {
    _: 'Good : 3088 - 3239',
    zh: '一般 : 3088 - 3239',
  },
  personalized_loan_q6_a4: {
    _: 'Poor : 2868 - 3087',
    zh: '欠佳 : 2868 - 3087',
  },
  personalized_loan_q6_a5: {
    _: 'Very poor : 1000 - 2867',
    zh: '欠佳／瀕臨破產 : 1000 - 2867',
  },
  personalized_loan_q6_a6: {
    _: "I'm not sure about my credit score",
    zh: '我不清楚我的信貸評級',
  },
  personalized_loan_q7: {
    _: "7. What's your mobile number?",
    zh: '7. 請留下你的聯絡電話',
  },
  personalized_loan_q8: {
    _: '8. What is your email address ?',
    zh: '8. 請留下你的電郵地址',
  },
  personalized_loan_not_sure: {
    _: "Not sure of your credit score? Click <a href='https://www.moneyhero.com.hk/zh/page/moneyhero-app' class='underline' target='_blank'>here</a> to check it for free!",
    zh: "不確定您的信用評分？點選<a href='https://www.moneyhero.com.hk/zh/page/moneyhero-app' class='underline' target='_blank'>此處</a>免費查看！",
  },
  personalized_loan_mobile_phone: {
    _: 'Complete the mobile phone',
    zh: '完成手機號碼填寫',
  },
  personalized_loan_mobile_email: {
    _: 'Complete the email address',
    zh: '完成電子郵件地址填寫',
  },
  personalized_loan_terms: {
    _: 'By clicking “Next”, I agree and consent to MoneyHero Global Limited and its affiliates (“MoneyHero”) processing my personal data:',
    zh: '按「下一步」，我同意並授權 MoneyHero Global Limited 及其相關公司（「MoneyHero」）處理我個人資料：',
  },
  personalized_loan_consent_1: {
    _: 'for the purposes set out in the Privacy Policy (including generating personalised financial product options, facilitating my product application and sending reminders); and',
    zh: '用於私隱政策中列明的目的（包括生成個人化金融產品選項、協助我的產品申請及發送提示電郵）；及',
  },
  personalized_loan_consent_2: {
    _: 'to send me marketing materials regarding products, services, offers & events of MoneyHero by email, phone call, IM or text,',
    zh: '通過電子郵件、電話、即時訊息、WhatsApp或短信向我發送有關 MoneyHero 產品、服務、優惠和活動的最新消息，',
  },
  personalized_loan_consent_3: {
    _: "each in accordance with MoneyHero’s <a href='https://www.moneyhero.com.hk/en/privacy-policy' target='_blank'>Privacy Policy</a> and <a href='https://www.moneyhero.com.hk/en/page/moneyhero-terms' target='_blank'>Terms and Conditions</a>. I understand I may opt-out by emailing <a href='mailto:support@moneyhero.com.hk'>support@moneyhero.com.hk.</a>",
    zh: "均符合 MoneyHero 的<a href='https://www.moneyhero.com.hk/en/privacy-policy' target='_blank'>隱私權政策</a>和<a href='https:// www .moneyhero.com.hk/en/page/moneyhero-terms' target='_blank'>條款及條件</a>。我了解我可以透過發送電子郵件至 <a href='mailto:support@moneyhero.com.hk'>support@moneyhero.com.hk</a> 更改。",
  },
  personalized_loan_calculating: {
    _: 'Fetching the best loan recommendations for you...',
    zh: '尋找適合你貸款產品中...',
  },
  personalized_loan_no_results: {
    _: "Unfortunately, we couldn't find any loans that match your answers.",
    zh: '抱歉，我們找不到適合你目前情況的貸款產品。',
  },
  personalized_loan_no_results_text: {
    _: 'No worries! You can adjust your responses to see more options or browse all available loans to find the perfect fit for your needs.',
    zh: '不用擔心！你可以調整你的答案以查看更多產品或查看其他可用貸款以找到最適合你的需求。',
  },
  personalized_loan_retake: {
    _: 'Retake the Questionnaire',
    zh: '重新填寫問卷',
  },
  personalized_loan_see_all: {
    _: 'See All Personal Loans',
    zh: '查看其他私人貸款',
  },
  personalized_loan_exlore_these: {
    _: 'Explore these loan options',
    zh: '探索這些貸款選擇',
  },
  personalized_loan_exlore_these_text: {
    _: 'We curated list of loans that match the answers you provided in the questionnaire.',
    zh: '我們整理了與你在問卷中提供的答案相符的貸款產品。',
  },
  personalized_loan_exlore_these_didnt_find: {
    _: "Didn't find what you're looking for among these loans?",
    zh: '在這裡中沒有找到您想要的貸款？',
  },
  personalized_loan_footer: {
    _: 'MoneyHero Global Limited (registered in Hong Kong under company number 1864714) (“MHGL”). All rights reserved.',
    zh: 'MoneyHero Global Limited（在香港註冊，公司編號1864714​​）（「MHGL」）。版權所有。',
  },
  back: {
    _: 'Back',
    zh: '返回',
  },
  next: {
    _: 'Next',
    zh: '下一步',
  },
  continue: {
    _: 'Continue',
    zh: '繼續',
  },
  offers: {
    _: 'Offers',
    zh: '優惠',
  },
  terms_and_conditions: {
    _: 'Terms and conditions',
    zh: '條款與細則',
  },
  privacy_and_policy: {
    _: 'Privacy Policy',
    zh: '隱私權政策',
  },
  tnc_description: {
    _: 'The information displayed above is for reference only. The actual rates offered to you will be based on your credit score and is subject to the provider’s approval.',
    zh: '以上資訊僅供參考，實際提供的利率將基於你的信用評分，並需經過金融機構審批。',
  },
  provider: {
    _: 'Provider',
    zh: '提供者',
  },
  loading: {
    _: 'Loading',
    zh: '加載中',
  },
  view_rewards: {
    _: 'View Rewards',
    zh: '查看獎賞',
  },
  more_details: {
    _: 'More Details',
    zh: '更多詳情',
  },
  sign_in_required: {
    _: 'Sing-in required',
    zh: '需要登入',
  },
  reviewed_on: {
    _: 'Reviewed on',
    zh: '評審日期',
  },
  default_title: {
    _: 'Default Title',
    zh: '預設標題',
  },
  product: {
    _: 'Product',
    zh: '產品',
  },
  annual_fee: {
    _: 'Annual Fee',
    zh: '年費',
  },
  minimum_annual_income: {
    _: 'Minimum Annual Income',
    zh: '最低年收入',
  },
  airport_lounge_access: {
    _: 'Airport Lounge Access',
    zh: '免費享用貴賓室次數',
  },
  rewards_points_baseline: {
    _: 'Rewards Points Baseline',
    zh: '基本獎賞點數',
  },
  monthly_repayment: {
    _: 'Monthly Repayment',
    zh: '每月還款額',
  },
  annual_interest_rate: {
    _: 'Annual Interest Rate',
    zh: '年利率',
  },
  annually_interest_rate: {
    _: 'Annual Interest Rate',
    zh: '年利率',
  },
  effective_interest_rate: {
    _: 'EIR',
    zh: '實際年利率',
  },
  processing_fee: {
    _: 'Processing Fee',
    zh: '手續費',
  },
  trip_cancellation: {
    _: 'Trip Cancellation',
    zh: '行程取消',
  },
  overseas_medical_expenses: {
    _: 'Overseas Medical Expenses',
    zh: '海外醫療費用',
  },
  loss_of_baggage: {
    _: 'Loss of Baggage',
    zh: '行李遺失',
  },
  TOTAL_INTEREST: {
    _: 'Total interest',
    zh: '總利息',
  },
  TOTAL_REWARDS_UP_TO: {
    _: 'Total rewards up to',
    zh: '總利息',
  },

  APR: {
    _: 'APR',
    zh: '最低實際年利率',
  },

  TOTAL_REPAYMENT: {
    _: 'Total repayment',
    zh: '總還款額低至',
  },

  REWARDS: {
    _: 'Rewards',
    zh: '獎賞',
  },
  see_all_rewards: {
    _: 'See all rewards',
    zh: '查看所有獎賞',
  },
  and: {
    _: 'and',
    zh: '和',
  },
  more: {
    _: 'More',
    zh: '更多',
  },
  complete_email: {
    _: 'Continue with Email',
    zh: '使用電子郵件繼續',
  },
  get_recommandation: {
    _: 'Get offers',
    zh: '獲取優惠',
  },
  skip_login: {
    _: 'Alternatively, you may skip login:',
    zh: '或者，您可以跳過登入。',
  },
  skip_for_now: {
    _: 'Skip for now',
    zh: '暫時跳過',
  },
  products: {
    _: 'Products',
    zh: '產品',
  },
  product_details: {
    _: 'Product details',
    zh: '信用卡詳情',
  },
  card: {
    _: 'Card',
    zh: '信用卡',
  },
  loan: {
    _: 'Loan',
    zh: '銀行/財務公司',
  },
  brand_reward_stk_bka: {
    _: 'SingSaver Reward',
    zh: 'SingSaver獨家獎賞',
  },
  brand_reward_product_modal: {
    _: 'SingSaver Reward',
    zh: 'SingSaver獨家獎賞',
  },
  brand_reward_product_modal_cc: {
    _: 'SingSaver Reward',
    zh: 'SingSaver獨家獎賞',
  },
  show_more_cards: {
    _: 'Show More Cards',
    zh: '显示更多卡片',
  },
  reward_elsewhere: {
    _: 'Reward Elsewhere',
    zh: '其他地方的奖励',
  },
  card_highlight: {
    _: 'Card Highlight',
    zh: '卡片亮点',
  },
  min_spend: {
    _: 'Monthly Spend Required',
    zh: '最低消费',
  },

  approval_speed: {
    _: 'Approval Speed',
    zh: '审批速度',
  },
  worth: {
    _: 'Worth',
    zh: '價值',
  },
  apply_through: {
    _: 'Apply through SingSaver and choose from :count premium rewards',
  },
  purchase_through: {
    _: 'Purchase through SingSaver and choose from :count premium rewards',
  },
  apply_through_stk_bka: {
    _: 'Apply through SingSaver and choose from :count premium rewards (Actual Gift eligibility depends on the deposit amount provided in the terms and conditions)',
    zh: '經MoneyHero申請，精選獎賞任你揀！獎賞選擇 :count (實際獎賞資格須視乎條款及細則所列的存款金額而定)',
  },
  premium_rewards: {
    _: 'premium rewards',
    zh: '尊貴獎賞」',
  },
  best_for: {
    _: '',
    zh: '',
  },
  benefits: {
    _: 'Benefits',
    zh: '優惠',
  },
  eligibility: {
    _: 'Eligibility',
    zh: '申請資格',
  },
  fees: {
    _: 'Fees',
    zh: '費用',
  },
  repayment: {
    _: 'Repayment',
    zh: '還款',
  },

  personal_loan_tenure: {
    _: 'Tenure (months)',
    zh: '還款期 (月)',
  },
  personal_loan_amount_help: {
    _: 'Most lenders offer loans between :currency:min_amount and :currency:max_amount depending on your profile.',
    zh: '大部分貸款機構提供的貸款額介乎:currency:min_amount至:currency:max_amount，實際批核金額視乎申請人個人資料而定',
  },
  personal_loan_tenure_help: {
    _: 'Loan tenure ranges from :min_tenure to :max_tenure months. Longer tenures mean smaller monthly payments but more interest overall.',
    zh: '還款期由:min_tenure至:max_tenure個月不等。還款期越長，每月供款壓力較低，但總利息支出會較高',
  },
  personal_loan_error: {
    _: 'Only {{min}}–{{max}} allowed',
    zh: '請輸入 {{min}} 至 {{max}} 之間的數字',
  },
  personal_loan_amount_min_error: {
    _: 'Greater than {{min}} allowed',
    zh: '請輸入大於 {{min}} 的數字',
  },
  personal_loan_months_error: {
    _: 'Only {{min}}–{{max}} months allowed',
    zh: ' 請輸入 {{min}} 至 {{max}} 之間的數字',
  },
  personal_loan_month_min_error: {
    _: 'Greater than {{min}} months allowed',
    zh: '請輸入大於 {{min}} 的數字',
  },
  things_to_consider: {
    _: 'Things To Consider',
    zh: 'MoneyHero 產品分析',
  },
  product_card_top_badge: {
    _: 'Product Card Top Badge',
    zh: '產品特色及優惠',
  },
  hide_summary: {
    _: 'Hide Summary',
    zh: '隱藏摘要',
  },
  features: {
    _: 'Features',
    zh: '產品特色及優惠',
  },
  long_description: {
    _: 'Long Description',
    zh: '詳細描述',
  },
  see: {
    _: 'See the',
    zh: '查看',
  },
  redirect_after_clicking: {
    _: 'You will be redirected to another page once you click on "Compare now"',
    zh: '點擊「立即比較」後，您將被重新導向至另一個頁面',
  },
  bank_gift: {
    _: `Bank Gift - On Top of SingSaver's`,
  },
  lender_gift: {
    _: `Lender Gift - On Top of SingSaver's`,
  },
  sta_bka_bank_gift: {
    _: `Provider Gift - On Top of SingSaver's`,
  },
  lender_gift_info: {
    _: `You’ll also receive the following welcome gift(s) directly from the lender`,
    zh: `金融機構亦會賞你以下迎新優惠`,
  },
  bank_gift_link: {
    _: `See the full welcome gift details`,
    zh: `查看優惠詳情`,
  },
  loan_reward_bank_gift: {
    _: `Your Loan Rewards & Bank Gifts`,
    zh: `你的貸款獨家獎賞與銀行優惠`,
  },
  loan_reward_lender_gift: {
    _: `Your Loan Rewards & Lender Gifts`,
    zh: `你的貸款獨家獎賞與金融機構優惠`,
  },
  loan_reward_provider_gift: {
    _: `Your Loan Rewards & Provider Gifts`,
    zh: `你的貸款獨家獎賞與金融機構優惠`,
  },
  insurance_reward_bank_gift: {
    _: `Your Insurance Rewards & Bank Gifts`,
    zh: `你的貸款獨家獎賞與銀行優惠`,
  },
  loan_amount_exclusive_bold: {
    _: `For a <b>:product</b> of <b>:currency:amount</b> over <b>:tenure</b> months, you’ll enjoy via <b>:brand</b>`,
    zh: `申請 <b>:product</b> <b>:currency:amount</b> 分 <b>:tenure</b> 個月 攤還，你將享有以下優惠：`,
  },
  travel_exclusive_bold: {
    _: `Purchase a <b>:product</b> via <b>:brand</b>`,
    zh: `經 :brand 投保 :product，精選獎賞任你揀！`,
  },
  up_cashback_rewards: {
    _: `Get up to :price in cashback & rewards`,
    zh: `獲得高達 :price 的現金回饋與獎勵`,
  },
  eligible_choose_reward: {
    _: `You’re eligible to choose one reward based on your loan amount and tenure`,
    zh: `根據你輸入的貸款金額及還款期，你可以選擇以下其中一份獎賞`,
  },
  eligible_choose_reward_without_tenure_and_amount: {
    _: `You’re eligible to choose one reward`,
    zh: `根據你輸入的貸款金額及還款期，你可以選擇以下其中一份獎賞`,
  },
  ineligible_choose_reward: {
    _: `For other loan amounts and tenures you can choose from`,
    zh: `其他貸款金額及還款期，你可以選擇以下其中一份獎賞`,
  },
  month_tenure: {
    _: `month tenure`,
    zh: `月 期限`,
  },
  show_term_cond: {
    _: `Show T&Cs`,
    zh: `顯示條款與細則`,
  },
  with_amount: {
    _: `with a top up of :amount`,
    zh: `需額外支付 :amount`,
  },

  lightdeal: {
    _: 'SingSaver Lightning Deal',
    zh: 'SingSaver 限時閃購優惠',
  },
  no_personal_loans_title: {
    _: 'No Personal Loans Match Your Criteria',
    zh: '搵唔到符合你條件嘅私人貸款計劃',
  },
  no_personal_loans_subtitle: {
    _: 'Try adjusting your loan amount or tenure to see more options.',
    zh: '試下調整你嘅貸款金額或還款期，可能會有更多選擇',
  },

  standout_tips: {
    _: 'SingSaver Tips',
    zh: 'SingSaver 理財建議',
  },
  standout_takeaways: {
    _: 'SingSaver Takeaways',
    zh: 'SingSaver 重點',
  },
  standout_perspective: {
    _: 'SingSaver Expert Perspective',
    zh: 'SingSaver 專家觀點',
  },
  standout_editors_pick: {
    _: "Editor's Pick",
    zh: '編輯推介',
  },
  spotlight_title: {
    _: 'Product Spotlight',
    zh: '產品特點',
  },
  spotlight_rewards: {
    _: 'Rewards',
    zh: '獎賞',
  },
  spotlight_apply: {
    _: 'Apply Now',
    zh: '立即申請',
  },
  spotlight_details: {
    _: 'View Details',
    zh: '查看詳情',
  },
  copied: {
    _: 'Copied!',
    zh: '已複製!',
  },
  timing: {
    _: '*Please note that agents are available from 9 a.m. to 6 p.m. weekdays SGT.',
    zh: '*請注意，客服代表在香港時間週一至週五上午9點至下午6點提供服務。',
  },
  helpText: {
    _: 'Find out if you have a Certificate of Merit (COM).',
    zh: '查看您是否有榮譽證書（COM）。',
  },
  brand: {
    _: 'Vehicle make',
    zh: '汽車品牌',
  },
  model: {
    _: 'Vehicle model',
    zh: '車型',
  },
  year_of_manufacture: {
    _: 'Year of manufacture',
    zh: '製造年份',
  },
  offence_free: {
    _: 'Do you have any demerit points?',
    zh: '您是否有資格獲得無違規折扣？',
  },
  gender: {
    _: 'Gender',
    zh: '性別',
  },
  marital_status: {
    _: 'Marital Status',
    zh: '婚姻狀況',
  },
  occupation_type: {
    _: 'Occupation Type',
    zh: '職業類型',
  },
  off_peak_vehicle: {
    _: 'Off-peak Vehicle',
    zh: '非尖峰時段車輛',
  },
  age: {
    _: 'Age',
    zh: '年齡',
  },
  driving_experience: {
    _: 'Driving Experience',
    zh: '駕駛經驗',
  },
  ncd: {
    _: 'NCD',
    zh: '無索償折扣',
  },
  number_of_claims: {
    _: 'Number of claims in last 3 years',
    zh: '過去3年內的理賠次數',
  },
  by_continuing: {
    _: 'By continuing, you agree to',
    zh: '繼續即表示您同意 MoneyHero 的',
  },
  variant: {
    _: 'Variant',
    // ph: "Variant"
  },
  contact_me: {
    _: 'Contact me',
    zh: '聯繫我',
  },
  or: {
    _: 'or',
    zh: '或',
  },
  WA: {
    _: 'WhatsApp us now',
    zh: '立即 WhatsApp 我們',
  },
  phone_now: {
    _: 'Call us now',
    zh: '立即致電我們',
  },
  email_now: {
    _: 'Email us now',
    zh: '立即發送電子郵件給我們',
  },
  marketing: {
    _: 'I consent to receive direct marketing material which includes newsletters, promotional materials and event information about the products and services of SingSaver and/or its affiliates by email, phone and/or other electronic means',
    zh: '我同意接收直接營銷資料，包括有關 MoneyHero 及/或其附屬公司產品和服務的電子郵件、電話及/或其他電子方式的新聞通訊、促銷材料和活動資訊。',
  },
  name_input: {
    _: 'Enter your full name',
    zh: '輸入您的全名',
  },
  email_input: {
    _: 'Enter your email',
    zh: '輸入您的電子郵件',
  },
  phone_input: {
    _: 'Enter your phone number',
    zh: '輸入您的電話號碼',
  },
  gender_male: {
    _: 'Male',
    zh: '男',
  },
  gender_female: {
    _: 'Female',
    zh: '女',
  },
  marital_status_single: {
    _: 'Single',
    zh: '單身',
  },
  marital_status_married: {
    _: 'Married',
    zh: '已婚',
  },
  indoor: {
    _: 'Indoor',
    zh: '室內',
  },
  outdoor: {
    _: 'Outdoor',
    zh: '室外',
  },
  yes: {
    _: 'Yes',
    zh: '是',
  },
  no: {
    _: 'No',
    zh: '否',
  },
  zero_years: {
    _: '0 years',
    zh: '0 年',
  },
  one_year: {
    _: '1 year',
    zh: '1 年',
  },
  two_years: {
    _: '2 years',
    zh: '2 年',
  },
  three_years_and_above: {
    _: '3 Years and Above',
    zh: '3 年及以上',
  },
  three_years: {
    _: '3 years',
    zh: '3 年',
  },
  four_years: {
    _: '4 years',
    zh: '4 年',
  },
  five_years_and_above: {
    _: '5 Years and Above',
    zh: '5 年及以上',
  },
  contact_info_subtitle: {
    _: 'Please leave us your contact details and we will get back to you as soon as possible.',
    zh: '請留下您的聯絡資料，我們將儘快與您聯繫。',
  },
  confirmation_modal_title: {
    _: 'Thank you for your interest in SingSaver, we will get back to you as soon as possible.',
    zh: '感謝您對 MoneyHero 的關注，我們將盡快與您聯繫。',
  },
  confirmation_modal_subtitle: {
    _: 'If you need urgent assistance feel free to drop us a message on WhatsApp.',
    zh: '如果您需要緊急協助，請隨時通過 WhatsApp 給我們發訊息。',
  },
  error_modal_title: {
    _: 'We faced an error while submitting your data',
    zh: '我們在提交您的資料時遇到錯誤',
  },
  error_modal_subtitle: {
    _: 'Something went wrong while submitting your information. Please try filling out the form again.',
    zh: '在提交您的資訊時出錯了。請再次嘗試填寫表格。',
  },
  try_again: {
    _: 'Try again',
    zh: '再試一次',
  },
  enter_valid_name: {
    _: 'Please enter a valid name',
    zh: '請輸入有效的姓名',
  },
  enter_valid_email: {
    _: 'Please enter a valid email address',
    zh: '請輸入有效的電子郵件地址',
  },
  enter_valid_phone: {
    _: 'Please enter a valid phone number',
    zh: '請輸入有效的電話號碼',
  },
  enquiry_purpose: {
    _: 'Enquiry Purpose',
    zh: '查詢目的',
  },
  select_enquiry_purpose: {
    _: 'Select enquiry purpose',
    zh: '選擇查詢目的',
  },
  i_dont_have_insurance: {
    _: "I don't have insurance",
    zh: '我沒有保險',
  },
  car_insurance_expiry: {
    _: 'Car insurance expiry date',
    zh: '汽車保險到期日',
  },
  select_month: {
    _: 'Select month',
    zh: '選擇月份',
  },
  full_name: {
    _: 'Full name',
    zh: '全名',
  },
  first_name: {
    _: 'First name',
  },
  last_name: {
    _: 'Last name',
  },
  preferred_contact_method: {
    _: 'Preferred contact method',
    zh: '首選聯絡方式',
  },
  phone_number: {
    _: 'Phone number',
    zh: '電話號碼',
  },
  email: {
    _: 'Email',
    zh: '電子郵件',
  },
  contact_info: {
    _: 'Contact info',
    zh: '聯絡資訊',
  },
  check: {
    _: 'Check',
    zh: '檢查',
  },
  vehicle_details: {
    _: 'Vehicle details',
  },
  vehicle_details_subtitle: {
    _: 'Please provide your vehicle details to get accurate quotes.',
  },
  personal_details: {
    _: 'Personal details',
  },
  personal_details_subtitle: {
    _: 'Please fill in your personal details.',
  },
  select_car_brand: {
    _: 'Select car brand',
  },
  select_car_model: {
    _: 'Select car model',
  },
  select_car_variant: {
    _: 'Select car variant',
  },
  search: {
    _: 'Search',
  },
  year: {
    _: 'Year',
  },
  buy_now: {
    _: 'Buy Now',
    zh: '立即購買',
  },
  fetch_price: {
    _: 'Fetching live pricing',
    zh: '正在獲取即時價格',
  },
  edit_quote_details: {
    _: 'Edit quote details',
  },
  enter_personal_details: {
    _: 'Please enter your personal details to get the best deal',
  },
  update_quote: {
    _: 'Update Quote',
  },
  edit_button: {
    _: 'Edit details',
    zh: '編輯詳情',
  },
  quote_pt_one: {
    _: 'The quote is for',
    zh: '以',
  },
  quote_pt_two: {
    _: 'years old with',
    zh: '年',
  },
  quote_pt_three: {
    _: 'years driving experience',
    zh: '車主',
  },
  quote_pt_four: {
    _: 'NCD and',
    zh: '年以上駕駛經驗及無索償折扣',
  },
  quote_pt_five: {
    _: 'number of claims.',
    zh: '%計算。',
  },
  years_old_short: {
    _: 'y/o',
  },
  years: {
    _: 'years',
  },
  coverage: {
    _: 'Coverage',
  },
  premium: {
    _: 'Premium',
  },
  act_nature: {
    _: 'Acts of Nature',
  },
  bodily_injury: {
    _: 'Bodily Injury',
  },
  property_damage: {
    _: 'Property Damage',
  },
  personal_accident: {
    _: 'Personal Accident',
  },
  doc_stamps: {
    _: 'Doc. Stamps (DST)',
  },
  local_gov: {
    _: 'Local Gov. (LGT)',
  },
  vat: {
    _: 'VAT',
  },
  type: {
    _: 'Type',
  },
  price: {
    _: 'Price',
  },
  net_premium: {
    _: 'Net Premium',
  },
  tax: {
    _: 'Tax',
  },
  tax_rate: {
    _: 'Tax Rate',
  },
  taxes_total: {
    _: 'Taxes Total',
  },
  primary_use_car: {
    _: 'What is the primary use of your car?',
  },
  interested_ctpl: {
    _: 'I am interested in Compulsory Third Party Liability (CTPL) Insurance',
  },
  receive_updates: {
    _: 'Yes, I would like to receive updates on exciting promos, rewards, and the latest info about products and services from Moneymax (Moneyguru and Moneyhero Philippines) through phone, email, and other electronic means.',
  },
  no_thank: {
    _: 'No, thank you.',
  },
  bodily_injury_property_damage: {
    _: 'Bodily injury & property damage coverage',
  },
  get_result: {
    _: 'Get Result',
  },
  off: {
    _: 'off',
    zh: '折扣',
  },
  your_reward: {
    _: 'Your Rewards',
    zh: '你的獎賞',
  },
  update_amount_tenure: {
    _: 'Update Loan Amount / Tenure to Qualify',
  },
  welcome_text_single: {
    _: 'Don’t miss out on this great deal!',
    zh: '唔好錯過呢啲超筍優惠！',
  },
  welcome_text: {
    _: 'Don’t miss out on these great deals:',
    zh: '唔好錯過呢啲超筍優惠！',
  },
  update_amount_tenure_unlock_reward: {
    _: 'Update your loan amount to at least <b>:prefix:amount</b> and loan tenure to at least <b>:tenure month</b> to unlock exclusive gifts',
  },
  worth_up_reward: {
    _: '<b>worth up to :prefix:reward</b>',
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} satisfies LocaleSpecificGroup<any>;
